module.exports = __webpack_public_path__ + "img/favicon.78f52e9d.svg";